import i18n from './../../../shared/i18n';
import BaseModel from "../../../core/components/input-widget/BaseModel";

export default class TaxStatusForm extends BaseModel {
  tax_status_uuid = '';

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  rules = {
    tax_status_uuid: 'required'
  };

  attributeLabels = {
    tax_status_uuid: i18n.t('Tax Status'),
    tax_status: i18n.t('Tax Status'),
  };
}
